// extracted by mini-css-extract-plugin
module.exports = {"switch":"dd31006766--switch--zSOGs","indicator":"dd31006766--indicator--MoK0B","label":"dd31006766--label--uLnzC"};